<div class="payout-dialog">
  <div class="dialog-close-button" (click)="onNoClick()">X</div>

  <div class="title">Vielen Dank !</div>

  <div class="text">Deine Auszahlung wird schnellst möglich bearbeitet.</div>

  <div class="text">
    Die maximale Bearbeitungszeit beträgt 1-2 Werktage. Sollest du eine Auszahlung per PayPal gewählt haben, erfolgt diese zumeinst schon innerhalb weniger Stunden
  </div>

  <div class="center">
    <div class="sport-button green big center" (click)="goToSports()">
      {{ 'Transactions_Dialog_Green_Button' | t }}
    </div>
  </div>
</div>
